import { connect } from 'react-redux'
import CounterLabeled from '../Components/CounterLabeled'
import { mapStateToProps, mapDispatchToProps } from '../Utils/mapToProps'

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CounterLabeled)
